import React, { useEffect,useState } from "react";
import { FaAward, FaXTwitter, FaLink } from "react-icons/fa6";


const styles = {
  page: {
    minHeight: "100%",
    backgroundColor: "#0f0f0f",
    color: "#ffffff",
    fontFamily: "Arial, sans-serif",
  },
  hero: {
    background: "linear-gradient(135deg, #312e81, #6d28d9, #be185d)",
    padding: "90px 20px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  container: {
    width: "100%",
    maxWidth: "1180px",
    margin: "0 auto",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "rgba(255,255,255,0.1)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "999px",
    padding: "10px 18px",
    fontSize: "13px",
    marginBottom: "22px",
  },
  title: {
    fontSize: "60px",
    lineHeight: "72px",
    fontWeight: "700",
    margin: 0,
  },
  subtitle: {
    maxWidth: "700px",
    marginTop: "24px",
    color: "rgba(255,255,255,0.75)",
    fontSize: "18px",
    lineHeight: "32px",
  },
  buttonRow: {
    display: "flex",
    gap: "16px",
    marginTop: "42px",
    flexWrap: "wrap",
  },
  primaryButton: {
    backgroundColor: "#ffffff",
    color: "#000000",
    padding: "14px 28px",
    borderRadius: "18px",
    textDecoration: "none",
    fontWeight: "600",
    display: "inline-block",
  },
  secondaryButton: {
    backgroundColor: "rgba(255,255,255,0.08)",
    color: "#ffffff",
    padding: "14px 28px",
    borderRadius: "18px",
    textDecoration: "none",
    border: "1px solid rgba(255,255,255,0.1)",
    display: "inline-block",
  },
  section: {
    padding: "80px 20px",
  },
  bookGrid: {
    display: "flex",
    gap: "40px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  imageContainer: {
    flex: "1 1 420px",
  },
  image: {
    width: "100%",
    borderRadius: "30px",
    minHeight: "520px",
    objectFit: "cover",
  },
  content: {
    flex: "1 1 420px",
  },
  sectionLabel: {
    fontSize: "13px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "#c4b5fd",
  },
  sectionTitle: {
    fontSize: "48px",
    marginTop: "16px",
    marginBottom: "12px",
    lineHeight: "58px",
  },
  text: {
    color: "rgba(255,255,255,0.72)",
    lineHeight: "30px",
    fontSize: "16px",
  },
  statsRow: {
    display: "flex",
    gap: "16px",
    marginTop: "30px",
    flexWrap: "wrap",
  },
  statCard: {
    backgroundColor: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "22px",
    padding: "20px",
    minWidth: "160px",
  },
  signupButton: {
    display: "inline-block",
    marginTop: "36px",
    backgroundColor: "#6366f1",
    color: "#ffffff",
    textDecoration: "none",
    padding: "16px 30px",
    borderRadius: "18px",
    fontWeight: "600",
  },
  booksSection: {
    backgroundColor: "#151515",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    padding: "80px 20px",
  },
  cardsGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    marginTop: "50px",
  },
  card: {
    flex: "1 1 300px",
    backgroundColor: "#1d1d1d",
    borderRadius: "28px",
    padding: "28px",
    border: "1px solid rgba(255,255,255,0.08)",
  },
  cardBadge: {
    display: "inline-block",
    backgroundColor: "rgba(99,102,241,0.2)",
    color: "#c7d2fe",
    borderRadius: "999px",
    padding: "8px 14px",
    fontSize: "12px",
  },
  cardTitle: {
    fontSize: "28px",
    marginTop: "24px",
    marginBottom: "10px",
  },
  outlineButton: {
    marginTop: "24px",
    background: "transparent",
    color: "#ffffff",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "16px",
    padding: "12px 18px",
    cursor: "pointer",
  },
  newsletterWrapper: {
    padding: "90px 20px",
  },
  newsletterBox: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "70px 40px",
    borderRadius: "36px",
    background:
      "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
    border: "1px solid rgba(255,255,255,0.08)",
    textAlign: "center",
  },
  form: {
    display: "flex",
    gap: "16px",
    marginTop: "40px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  input: {
    minWidth: "320px",
    height: "56px",
    borderRadius: "18px",
    border: "1px solid rgba(255,255,255,0.1)",
    backgroundColor: "rgba(0,0,0,0.3)",
    color: "#ffffff",
    padding: "0 18px",
    outline: "none",
  },
};

// const MailchimpSubscribe = () => {
//   return (
//     <div
//       style={{
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//         padding: "40px 16px",
//         backgroundColor: "#f5f5f5",
//         boxSizing: "border-box",
//          backgroundImage:
//       "url('https://images.assettype.com/newslaundry/2026-05-19/u513j171/banner-.jpg')",
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "600px",
//           backgroundColor: "var(--background-neutral-muted)",
//           padding: "32px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//           fontFamily: "Helvetica, Arial, sans-serif",
//           boxSizing: "border-box",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         {/* <h2
//           style={{
//             margin: "0 0 24px 0",
//             fontSize: "28px",
//             fontWeight: "700",
//             color: "#000",
//           }}
//         >
//           Subscribe
//         </h2> */}

//         <form
//           action="https://newslaundry.us8.list-manage.com/subscribe/post?u=5e61bb00776ee2d0b506524bd&id=bd83706984&f_id=0075d0e1f0"
//           method="post"
//           // target="_blank"
//           noValidate
//         >
//           {/* Email */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               htmlFor="mce-EMAIL"
//               style={{
//                 all: "unset",
//                 display: "block",
//                 marginBottom: "8px",
//                 fontWeight: "600",
//                 fontSize: "14px",
//                 color: "var(--text-accent-default)",
//                 fontFamily: "Helvetica, Arial, sans-serif",
//               }}
//             >
//               Email Address *
//             </label>

//             <input
//               type="email"
//               name="EMAIL"
//               id="mce-EMAIL"
//               required
//               placeholder="Enter your email"
//               autoComplete="email"
//               style={{
//                 all: "unset",
//                 width: "100%",
//                 padding: "12px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "16px",
//                 backgroundColor: "#fff",
//                 color: "#000",
//                 boxSizing: "border-box",
//                 pointerEvents: "auto",
//                 position: "relative",
//                 zIndex: 10,
//               }}
//             />
//           </div>

//           {/* First Name */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               htmlFor="mce-FNAME"
//               style={{
//                 all: "unset",
//                 display: "block",
//                 marginBottom: "8px",
//                 fontWeight: "600",
//                 fontSize: "14px",
//                 color: "var(--text-accent-default)",
//                 fontFamily: "Helvetica, Arial, sans-serif",
//               }}
//             >
//               First Name *
//             </label>

//             {/* <input
//               type="text"
//               name="FNAME"
//               id="mce-FNAME"
//               required
//               placeholder="Enter your first name"
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 fontSize: "16px",
//                 boxSizing: "border-box",
//               }}
//             /> */}
//             <input
//               type="text"
//               name="FNAME"
//               id="mce-FNAME"
//               required
//               placeholder="Enter your first name"
//               autoComplete="given-name"
//               style={{
//                 all: "unset",
//                 width: "100%",
//                 padding: "12px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "16px",
//                 backgroundColor: "#fff",
//                 color: "#000",
//                 boxSizing: "border-box",
//                 pointerEvents: "auto",
//                 position: "relative",
//                 zIndex: 10,
//               }}
//             />
//           </div>

//           {/* Last Name */}
//           <div style={{ marginBottom: "20px" }}>
//             <label
//               htmlFor="mce-LNAME"
//               style={{
//                 all: "unset",
//                 display: "block",
//                 marginBottom: "8px",
//                 fontWeight: "600",
//                 fontSize: "14px",
//                  color: "var(--text-accent-default)",
//                 fontFamily: "Helvetica, Arial, sans-serif",
//               }}
//             >
//               Last Name
//             </label>

//             {/* <input
//               type="text"
//               name="LNAME"
//               id="mce-LNAME"
//               placeholder="Enter your last name"
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 fontSize: "16px",
//                 boxSizing: "border-box",
//               }}
//             /> */}
//             <input
//               type="text"
//               name="LNAME"
//               id="mce-LNAME"
//               placeholder="Enter your last name"
//               autoComplete="family-name"
//               style={{
//                 all: "unset",
//                 width: "100%",
//                 padding: "12px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "16px",
//                 backgroundColor: "#fff",
//                 color: "#000",
//                 boxSizing: "border-box",
//                 pointerEvents: "auto",
//                 position: "relative",
//                 zIndex: 10,
//               }}
//             />
//           </div>

//           {/* Phone Number */}
//           <div style={{ marginBottom: "24px" }}>
//             <label
//               htmlFor="mce-MMERGE3"
//               style={{
//                 all: "unset",
//                 display: "block",
//                 marginBottom: "8px",
//                 fontWeight: "600",
//                 fontSize: "14px",
//                   color: "var(--text-accent-default)",
//                 fontFamily: "Helvetica, Arial, sans-serif",
//               }}
//             >
//               Phone Number
//             </label>

//             {/* <input
//               type="tel"
//               name="MMERGE3"
//               id="mce-MMERGE3"
//               placeholder="+91 9876543210"
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 fontSize: "16px",
//                 boxSizing: "border-box",
//               }}
//             /> */}
//             <input
//               type="tel"
//               name="PHONE"
//               id="mce-PHONE"
//               placeholder="+91 9876543210"
//               autoComplete="tel"
//               style={{
//                 all: "unset",
//                 width: "100%",
//                 padding: "12px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "16px",
//                 backgroundColor: "#fff",
//                 color: "#000",
//                 boxSizing: "border-box",
//                 pointerEvents: "auto",
//                 position: "relative",
//                 zIndex: 10,
//               }}
//             />
//           </div>

//           {/* Hidden bot protection field */}
//           <div
//             aria-hidden="true"
//             style={{
//               position: "absolute",
//               left: "-5000px",
//             }}
//           >
//             <input
//               type="text"
//               name="b_5e61bb00776ee2d0b506524bd_bd83706984"
//               tabIndex="-1"
//               defaultValue=""
//             />
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             style={{
//               width: "40%",
//               padding: "14px",
//              backgroundColor: "var(--component-background-accent-solid-default)",
//               color: "#fff",
//               border: "none",
//               borderRadius: "8px",
//               fontSize: "16px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//           >
//             Subscribe
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

const MailchimpSubscribe = () => {
  return (
    <div
      style={{
        width: "100%",
        // minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 16px",
        boxSizing: "border-box",

        /* BACKGROUND IMAGE */
        backgroundImage:
          "url('https://images.assettype.com/newslaundry/2026-05-21/6vphogk3/bookClub.jpg')",

        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* FORM CARD */}
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "var(--accent-3)",
          backdropFilter: "blur(6px)",
          padding: "32px 28px",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          fontFamily: "Helvetica, Arial, sans-serif",
          boxSizing: "border-box",
        }}
      >
        {/* HEADING */}
        {/* <h2
          style={{
            margin: "0 0 12px 0",
            fontSize: "32px",
            fontWeight: "700",
            color: "#000",
          }}
        >
          Subscribe to Newsletter
        </h2>

        <p
          style={{
            marginBottom: "28px",
            color: "#555",
            fontSize: "16px",
            lineHeight: "24px",
          }}
        >
          Get the latest updates, stories and exclusive content directly in your
          inbox.
        </p> */}

        {/* FORM */}
        <form
          action="https://newslaundry.us8.list-manage.com/subscribe/post"
          method="POST"
          acceptCharset="UTF-8"
          noValidate
          id="subscribe-form"
        >
          {/* HIDDEN MAILCHIMP FIELDS */}
          <input type="hidden" name="u" value="5e61bb00776ee2d0b506524bd" />

          <input type="hidden" name="id" value="bd83706984" />

          <input type="hidden" name="f_id" value="0075d0e1f0" />

          {/* EMAIL */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="mce-EMAIL"
              style={{
                all: "unset",
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                fontSize: "14px",
                color: "var(--accent-12)",
              }}
            >
              Email Address *
            </label>

            <input
              type="email"
              name="EMAIL"
              id="mce-EMAIL"
              required
              placeholder="Enter your email"
              autoComplete="email"
              style={{
                all: "unset",
                width: "100%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#fff",
                color: "#000",
                boxSizing: "border-box",
                pointerEvents: "auto",
                position: "relative",
                zIndex: 10,
              }}
            />
          </div>

          {/* FIRST NAME */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="mce-FNAME"
              style={{
                all: "unset",
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                fontSize: "14px",
                color: "var(--accent-12)",
              }}
            >
              First Name *
            </label>

            <input
              type="text"
              name="FNAME"
              id="mce-FNAME"
              required
              placeholder="Enter your first name"
              autoComplete="given-name"
              style={{
                all: "unset",
                width: "100%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#fff",
                color: "#000",
                boxSizing: "border-box",
                pointerEvents: "auto",
                position: "relative",
                zIndex: 10,
              }}
            />
          </div>

          {/* LAST NAME */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="mce-LNAME"
              style={{
                all: "unset",
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                fontSize: "14px",
                color: "var(--accent-12)",
              }}
            >
              Last Name
            </label>

            <input
              type="text"
              name="LNAME"
              id="mce-LNAME"
              placeholder="Enter your last name"
              autoComplete="family-name"
              style={{
                all: "unset",
                width: "100%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#fff",
               color: "#000",
                boxSizing: "border-box",
                pointerEvents: "auto",
                position: "relative",
                zIndex: 10,
              }}
            />
          </div>

          {/* PHONE NUMBER */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="mce-MMERGE3"
              style={{
                all: "unset",
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                fontSize: "14px",
                color: "var(--accent-12)",
              }}
            >
              Phone Number*
            </label>

            <input
              type="tel"
              name="MMERGE3"
              id="mce-MMERGE3"
              placeholder="+91 9876543210"
              autoComplete="tel"
              required
              style={{
                all: "unset",
                width: "100%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#fff",
                color: "#000",
                boxSizing: "border-box",
                pointerEvents: "auto",
                position: "relative",
                zIndex: 10,
              }}
            />
          </div>

          {/* DROPDOWN */}
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="mce-MMERGE4"
              style={{
                all: "unset",
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                fontSize: "14px",
                color: "var(--accent-12)",
              }}
            >
             Choose Your House*
            </label>

            <select
              name="MMERGE4"
              id="mce-MMERGE4"
              required
              style={{
                all: "unset",
                width: "100%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#fff",
                color: "#000",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
            >
              <option value="" >
                Select House:
              </option>

              <option value="The Skippers: People who pick up a book and skip to the end">
               The Skippers: People who pick up a book and skip to the end
              </option>

              <option value="The Spinecrackers: People who break the spine when reading">
               The Spinecrackers: People who break the spine when reading
              </option>

              <option value="The Hoarders: People who buy more books than they read">
               The Hoarders: People who buy more books than they read
              </option>

              <option value="The Abandoners: People who rarely finish their books">
               The Abandoners: People who rarely finish their books
              </option>
            </select>
          </div>

          {/* BOT PROTECTION */}
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              left: "-5000px",
            }}
          >
            <input
              type="text"
              name="b_5e61bb00776ee2d0b506524bd_bd83706984"
              tabIndex="-1"
              defaultValue=""
            />
          </div>

          {/* SUBMIT BUTTON */}
      <div style={{display:'flex', justifyContent:'center'}}>
    <button
            type="submit"
            style={{
              // width: "50%",
              padding: "14px",
              backgroundColor: "var(--component-background-accent-solid-default)",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              alignSelf: "center",

            }}
          >
            SUBSCRIBE NOW
          </button>

      </div>
        </form>
      </div>
    </div>
  );
};
function BannerSection() {
  return (
    <section style={styles.hero}>
      <div style={styles.container}>
        <div style={styles.badge}>📚 Weekly Reading Sessions</div>

        <h1 style={styles.title}>Welcome to the Modern Book Club</h1>

        <p style={styles.subtitle}>
          Read meaningful books, join thoughtful discussions, and connect with
          curious minds from around the world.
        </p>

        <div style={styles.buttonRow}>
          <a href="#book-section" style={styles.primaryButton}>
            Explore Current Book
          </a>

          <a href="#newsletter" style={styles.secondaryButton}>
            Join Newsletter
          </a>
        </div>
      </div>
    </section>
  );
}

function CurrentBookSection({ currentBook }) {
  return (
    <section id="book-section" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.bookGrid}>
          <div style={styles.imageContainer}>
            <img
              src="https://images.unsplash.com/photo-1512820790803-83ca734da794?q=80&w=1200&auto=format&fit=crop"
              alt="Book"
              style={styles.image}
            />
          </div>

          <div style={styles.content}>
            <div style={styles.sectionLabel}>Current Book Of The Month</div>

            <h2 style={styles.sectionTitle}>{currentBook.title}</h2>

            <p style={styles.text}>by {currentBook.author}</p>

            <p style={{ ...styles.text, marginTop: "24px" }}>
              {currentBook.description}
            </p>

            <div style={styles.statsRow}>
              <div style={styles.statCard}>
                <div style={styles.text}>Length</div>
                <h4>{currentBook.pages}</h4>
              </div>

              <div style={styles.statCard}>
                <div style={styles.text}>Meeting</div>
                <h4>Every Saturday</h4>
              </div>
            </div>

            <a href={currentBook.signupLink} style={styles.signupButton}>
              Sign Up For This Book
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function UpcomingBooksSection({ upcomingBooks }) {
  return (
    <section style={styles.booksSection}>
      <div style={styles.container}>
        <div style={styles.sectionLabel}>Reading Queue</div>

        <h2 style={styles.sectionTitle}>Upcoming Books</h2>

        <div style={styles.cardsGrid}>
          {upcomingBooks.map((book) => (
            <div key={book.title} style={styles.card}>
              <div style={styles.cardBadge}>{book.month}</div>

              <h3 style={styles.cardTitle}>{book.title}</h3>

              <p style={styles.text}>by {book.author}</p>

              {/* <button style={styles.outlineButton}>Notify Me</button> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  return (
    <section id="newsletter" style={styles.newsletterWrapper}>
      <div style={styles.newsletterBox}>
        <div style={styles.sectionLabel}>Stay Updated</div>

        <h2 style={styles.sectionTitle}>Join Our Newsletter</h2>

        <p style={styles.text}>
          Get weekly reading notes, discussion reminders, curated book
          recommendations, and updates directly in your inbox.
        </p>

        <form style={styles.form}>
          <input
            type="email"
            placeholder="Enter your email"
            style={styles.input}
          />

          <button type="submit" style={styles.primaryButton}>
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
}

export function BookClubPage() 
{
  const [loading, setLoading] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    // fallback in case onLoad never fires
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!mounted) {
    return  <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
                color:'var(--accent-12)'
          }}
        >
          Please wait loading...
        </div>
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "500px",
      }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
            color:'var(--accent-12)'
          }}
        >
                 Please wait loading...
        </div>
      )}

      <iframe
        src="https://cloud.content.thenewsminute.com/book-club"
        title="Iframe"
        onLoad={() => {
          console.log("iframe loaded");
          setLoading(false);
        }}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
}
// {
//   const currentBook = {
//     title: "Atomic Habits",
//     author: "James Clear",
//     description:
//       "A practical guide to building better habits, improving productivity, and making small changes that compound into remarkable results.",
//     pages: "320 Pages",
//     signupLink: "https://eepurl.com/AsKz8FHuYY",
//   };

//   const upcomingBooks = [
//     {
//       title: "Deep Work",
//       author: "Cal Newport",
//       month: "June 2026",
//     },
//     {
//       title: "The Psychology of Money",
//       author: "Morgan Housel",
//       month: "July 2026",
//     },
//     {
//       title: "The Almanack of Naval Ravikant",
//       author: "Eric Jorgenson",
//       month: "August 2026",
//     },
//   ];

//   return (
//     <div style={styles.page}>
//       {/* <BannerSection />

//       <CurrentBookSection currentBook={currentBook} />

//       <UpcomingBooksSection upcomingBooks={upcomingBooks} />

//       <NewsletterSection /> */}
//       {/* <MailchimpSubscribe /> */}
//   <iframe
//       src="https://cloud.content.thenewsminute.com/book-club"
//       width="100%"
//       height="560"
//       style={{
//         border: "none",
//       }}
//       title="Book Club Form"
//     />
//       {/* Current Book Section */}
//     </div>
//   );
// }
